import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

const rejectPendingCompany = createAction(`${nameSpace}/reject`);
const acceptPendingCompany = createAction(`${nameSpace}/accept`);
const fetchSubscriptions = createAction(`${nameSpace}/subs`);
export { rejectPendingCompany, acceptPendingCompany, fetchSubscriptions };
